var render = function render(_c,_vm){return _c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"progress-bar__wrapper"},[_c('div',{staticClass:"progress-bar__bar",style:(`width: ${_vm.props.value}%`)})])])
}
var staticRenderFns = []

export { render, staticRenderFns }